import { render } from "./ExperienceEducation.vue?vue&type=template&id=76545252&scoped=true"
const script = {}

import "./ExperienceEducation.vue?vue&type=style&index=0&id=76545252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76545252"]])

export default __exports__